/** Exact consumer / personal inbox domains. */
const COMMON_FREE_EMAIL_DOMAINS = new Set([
  "163.com",
  "africamail.com",
  "aol.com",
  "att.net",
  "bigpond.com",
  "blueyonder.co.uk",
  "btinternet.com",
  "centrum.cz",
  "comcast.net",
  "dodo.com.au",
  "gmail.com",
  "gmx.com",
  "gmx.net",
  "googlemail.com",
  "hotmail.com",
  "icloud.com",
  "iinet.net",
  "iinet.net.au",
  "libero.it",
  "live.com",
  "mac.com",
  "mail.com",
  "me.com",
  "mindspring.com",
  "mozilla.com",
  "mweb.co.za",
  "naver.com",
  "ntlworld.com",
  "optusnet.com",
  "optusnet.com.au",
  "outlook.com",
  "pm.me",
  "proton.me",
  "protonmail.com",
  "qq.com",
  "safrica.com",
  "sky.com",
  "telkomsa.net",
  "tuta.com",
  "tutanota.com",
  "ukr.net",
  "vodamail.co.za",
  "web.co.za",
  "web.de",
  "webmail.co.za",
  "yahoo.com",
  "yandex.com",
  "yandex.ru",
  "ymail.com",
  "rocketmail.com",
  "zohomail.com",
  "zoho.com",
]);

/**
 * Provider roots matched as `name.com`, `name.*`, or `*.name.com`
 * (covers regional variants like hotmail.co.uk, yahoo.com.au).
 */
const FREE_EMAIL_PROVIDER_ROOTS = [
  "aol",
  "gmail",
  "hotmail",
  "icloud",
  "iinet",
  "lantic",
  "live",
  "mozilla",
  "ntlworld",
  "optusnet",
  "outlook",
  "protonmail",
  "tutanota",
  "webmail",
  "yahoo",
  "yandex",
  "zohomail",
] as const;

export const WORK_EMAIL_VALIDATION_MESSAGE =
  "Please use your work email address to continue.";

export const WORK_EMAIL_HINT_MESSAGE =
  "We recommend using your work email address to help us better understand and assist with your business needs.";

/** Soft tip for free/personal inboxes on non–add-listing forms. */
export function pickRandomWorkEmailHint(): string {
  return WORK_EMAIL_HINT_MESSAGE;
}

function emailDomain(email: string): string {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at <= 0 || at === trimmed.length - 1) return "";
  return trimmed.slice(at + 1);
}

function isConsumerProviderDomain(domain: string): boolean {
  if (COMMON_FREE_EMAIL_DOMAINS.has(domain)) return true;

  return FREE_EMAIL_PROVIDER_ROOTS.some(
    (root) =>
      domain === `${root}.com` ||
      domain.startsWith(`${root}.`) ||
      domain.endsWith(`.${root}.com`),
  );
}

/** True for public inboxes such as gmail.com or yahoo.com. Business domains return false. */
export function isCommonFreeEmail(email: string): boolean {
  const domain = emailDomain(email);
  if (!domain) return false;
  return isConsumerProviderDomain(domain);
}
